import { component } from 'picoapp';
import { throttle } from 'lodash';

export default component((node) => {
  const transparentClass = 'header--transparent';

  const initHeaderHeight = () => {
    const storeHeight = (): void => {
      const clientRect = node.getBoundingClientRect();
      const { height } = clientRect;

      document.documentElement.style.setProperty('--header-height', `${height}px`);
    };

    storeHeight();
    window.addEventListener('resize', storeHeight);
  };

  const initTransparency = () => {
    if (!node.classList.contains(transparentClass)) {
      return;
    }

    const updateTransparency = () => {
      node.classList[window.scrollY > 0 ? 'remove' : 'add'](transparentClass);
    };

    window.addEventListener('scroll', throttle(updateTransparency, 100));
    updateTransparency();
  };

  const initMenuAnimations = () => {
    const menuItems = [...node.querySelectorAll<HTMLElement>('[data-header-menu-item]')];
    menuItems.forEach((menuItem) => {
      const navContainers = [...menuItem.querySelectorAll<HTMLElement>('[data-nav-item-container]')];

      navContainers.forEach((navContainer) => {
        const navItems = [...navContainer.querySelectorAll<HTMLElement>('[data-nav-item]')];

        menuItem.addEventListener('mouseenter', () => {
          navItems.forEach((item, index) => {
            item.classList.add('opacity-0');
            item.classList.remove('opacity-100');
            item.classList.add('animate-fade-bottom-top');
            item.style.animation = `fade-bottom-top 0.5s ease forwards ${index * 0.1}s`;
            item.addEventListener('animationend', () => {
              item.classList.add('opacity-100');
              item.classList.remove('opacity-0');
              item.style.animation = '';
            });
          });
        });

        menuItem.addEventListener('mouseleave', () => {
          navItems.forEach((item, index) => {
            item.classList.add('opacity-0');
            item.classList.remove('opacity-100');
            item.classList.add('animate-fade-top-bottom');
            item.style.animation = `fade-top-bottom 0.5s ease forwards ${index * 0.1}s`;
            item.addEventListener('animationend', () => {
              item.classList.add('opacity-100');
              item.classList.remove('opacity-0');
              item.style.animation = '';
            });
          });
        });
      });
    });
  };

  const init = () => {
    initHeaderHeight();
    initTransparency();
    initMenuAnimations();
  };

  init();
});
